export default __webpack_public_path__ + "static/media/AARP dark.1a14bfef.svg";